import {
  PURPOSE_ADS,
  PURPOSE_CONTENT,
  PURPOSE_ID_STORAGE,
  PURPOSE_ID_PERSONAL,
  PURPOSE_ID_ADS,
  PURPOSE_ID_CONTENT,
  PURPOSE_ID_MEASUREMENT
} from '../constants';

const list = {
  [PURPOSE_ADS]: true,
  [PURPOSE_CONTENT]: true
};

/**
 * Returns list of purposes whose checked values are based on data from Profile.
 * In case that data.consents[XXX] !== 'boolean' user does not have any consent in Profile.
 * @param {Object} data
 * @return {Object}
 */
export const getPreFilledPurposes = data => {
  if (data && data.consents) {
    const {consents} = data;

    list[PURPOSE_ADS] = typeof consents[PURPOSE_ADS] === 'boolean' ? consents[PURPOSE_ADS] : true;
    list[PURPOSE_CONTENT] = typeof consents[PURPOSE_CONTENT] === 'boolean' ? consents[PURPOSE_CONTENT] : true;
  }

  return list;
};

export const getPreFilledPurposesFromCookie = data => {
  if (data) {
    list[PURPOSE_ADS] = data.indexOf(PURPOSE_ID_ADS) !== -1;
    list[PURPOSE_CONTENT] = data.indexOf(PURPOSE_ID_CONTENT) !== -1;
  }

  return list;
};

/**
 * Returns formatted purposes for Profile.
 * @param {Object} data
 * @return {Object}
 */
export const getProfilePurposes = data => ({
  [PURPOSE_ADS]: data[PURPOSE_ADS],
  [PURPOSE_CONTENT]: data[PURPOSE_CONTENT]
});

/**
 * Sets purpose consents into consentData.
 * @param {ConsentString} consentData
 * @param {Object} purposes
 */
export const setPurposesToConsent = (consentData, purposes) => {
  consentData.setPurposeAllowed(PURPOSE_ID_STORAGE, true);
  consentData.setPurposeAllowed(PURPOSE_ID_PERSONAL, true);
  consentData.setPurposeAllowed(PURPOSE_ID_ADS, purposes[PURPOSE_ADS]);
  consentData.setPurposeAllowed(PURPOSE_ID_CONTENT, purposes[PURPOSE_CONTENT]);
  consentData.setPurposeAllowed(PURPOSE_ID_MEASUREMENT, true);
};
